import React, { Component } from "react";
import axios from "axios";
import Dropzone from "react-dropzone";
import Attach from "../../resources/icons/Attach.jsx";
import CloudUpload from "../../resources/icons/CloudUpload.jsx";
import CheckmarkSharp from "../../resources/icons/CheckmarkSharp.jsx";
import Send from "../../resources/icons/Send.jsx";

class MsgPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      chatId: props.chatId,
      sending: false,
      mute: false,
      attachments: [],
      fileProgress: null,
      dropZoneOpened: false,
      percentsLoad: 0,
      loading: false,
      bad_mime: false,
      allowed_mime: props.allowed_mime,
      allowed_mime_list: "",
    };
    this.msgRef = React.createRef();
    this._handleKeyDown = this._handleKeyDown.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.getFiles = this.getFiles.bind(this);
    this.toggleDropZone = this.toggleDropZone.bind(this);
  }
  static getDerivedStateFromProps(nextProps, prevProps) {
    return {
      chatId: nextProps.chatId,
      allowed_mime: nextProps.allowed_mime,
      allowed_mime_list: nextProps.allowed_mime
        ? Object.keys(nextProps.allowed_mime)
            .sort((a, b) => a - b)
            .join(", ")
        : "",
    };
  }
  componentWillUnmount() {
    return {
      dropZoneOpened: false,
    };
  }
  _handleKeyDown(e) {
    if (e.keyCode === 13 && e.shiftKey) {
    } else if (e.keyCode === 13) {
      e.preventDefault();
      this.sendMessage();
    }
  }
  toggleDropZone() {
    this.setState((prevState) => ({
      dropZoneOpened: !prevState.dropZoneOpened,
      bad_mime: false,
    }));
  }

  getFiles(files) {
    if (!files || files.length === 0) return;

    const rxExt = /^.+\.([^\.]+)$/;

    const existingFileNames = this.state.attachments.map(
      (attachment) => attachment.file_name,
    );

    const uniqueFiles = files.filter(
      (file) => !existingFileNames.includes(file.name),
    );

    if (uniqueFiles.length === 0) {
      this.setState({
        dropZoneOpened: false,
        bad_mime: false,
      });

      return;
    }

    const badFile = uniqueFiles.find((file) => {
      const ext = rxExt.exec(file.name);
      return ext && !this.props.allowed_mime[ext[1].toLowerCase()];
    });

    if (badFile) {
      const ext = rxExt.exec(badFile.name);

      console.log(ext?.[1]);

      this.setState({
        bad_mime: true,
      });

      return;
    }

    const loadedByFile = {};

    const newAttachmentsPreview = uniqueFiles.map((file) => ({
      file_name: file.name,
      uuid: "",
      attached: true,
      loading: true,
    }));

    this.setState((prevState) => ({
      dropZoneOpened: false,
      bad_mime: false,
      loading: true,
      mute: true,
      percentsLoad: 0,
      attachments: [...prevState.attachments, ...newAttachmentsPreview],
    }));

    Promise.all(
      uniqueFiles.map((file, index) =>
        axios.request({
          method: "post",
          url:
            this.props.mentorChatApiRoot +
            "/file/upload?token=" +
            localStorage.getItem("mentor_chat_token") +
            "&file_name=" +
            encodeURIComponent(file.name),
          data: file,
          onUploadProgress: (p) => {
            loadedByFile[index] = p.loaded;

            const totalLoaded = Object.values(loadedByFile).reduce(
              (sum, loaded) => sum + loaded,
              0,
            );

            const totalSize = uniqueFiles.reduce(
              (sum, file) => sum + file.size,
              0,
            );

            this.setState({
              percentsLoad: (totalLoaded / totalSize) * 100,
              loading: true,
              mute: true,
            });
          },
        }),
      ),
    )
      .then((responses) => {
        const uploadedAttachments = responses.map((response) => ({
          file_name: response.data.file_name,
          uuid: response.data.uuid,
          loading: false,
        }));

        this.setState((prevState) => {
          const oldAttachments = prevState.attachments.filter(
            (attachment) => !attachment.loading,
          );

          return {
            percentsLoad: 0,
            loading: false,
            mute: false,
            attachments: [...oldAttachments, ...uploadedAttachments],
          };
        });
      })
      .catch((error) => {
        console.log(error);

        this.setState({
          error,
          percentsLoad: 0,
          loading: false,
          mute: false,
        });
      });
  }

  sendMessage() {
    const hasText =
      this.msgRef.current && this.msgRef.current.innerText.length > 0;

    const attachments = this.state.attachments
      .filter((attachment) => attachment.uuid)
      .map((attachment) => ({
        uuid: attachment.uuid,
        file_name: attachment.file_name,
      }));

    const attached = attachments.length > 0;

    if (this.msgRef.current && (hasText || attached) && !this.state.sending) {
      this.state.sending = true;

      this.setState({ mute: true });

      fetch(this.props.mentorChatApiRoot + "/message/send", {
        method: "POST",
        cache: "no-cache",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: localStorage.getItem("mentor_chat_token"),
          chat_id: this.state.chatId,
          text: this.msgRef.current.innerText,
          attached,
          attachments,
        }),
      })
        .then((res) => res.json())
        .then(
          (result) => {
            if (result.ok) {
              this.msgRef.current.innerText = "";
            }

            this.state.sending = false;

            this.setState({
              mute: false,
              attachments: [],
              percentsLoad: 0,
              loading: false,
              dropZoneOpened: false,
            });
          },
          // Примечание: важно обрабатывать ошибки именно здесь, а не в блоке catch(),
          // чтобы не перехватывать исключения из ошибок в самих компонентах.
          (error) => {
            console.log(error);

            this.setState({
              error,
            });

            this.state.sending = false;
            this.setState({ mute: false });
          },
        );
    }
  }

  render() {
    const {
      dropZoneOpened,
      bad_mime,
      allowed_mime_list,
      attachments = [],
      loading,
      percentsLoad,
      mute,
    } = this.state;

    const hasAttachments = attachments.length > 0;

    return (
      <div
        className="MentorChatMsgPanel"
        style={mute ? { pointerEvents: "none", opacity: "0.6" } : {}}
      >
        <div className="ChatAttachmentButton" onClick={this.toggleDropZone}>
          <Attach color="#707070" height="50px" width="50px" />
        </div>

        {dropZoneOpened ? (
          <Dropzone
            multiple
            onDrop={(acceptedFiles) => this.getFiles(acceptedFiles)}
          >
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps()} className="FileDropZone">
                  <input {...getInputProps()} multiple />
                  Перетащите файл в данную область <br />
                  <div>
                    <CloudUpload color="#707070" height="65px" width="65px" />
                  </div>
                  {bad_mime ? (
                    <span style={{ color: "#f00" }}>
                      не допустимый тип файла, можно отправлять только документы
                      и изображения следующих типов:
                      <br />
                      {allowed_mime_list}
                    </span>
                  ) : (
                    <>
                      или нажмите на нее для открытия <br />
                      диалога выбора файла.
                    </>
                  )}
                </div>
              </section>
            )}
          </Dropzone>
        ) : hasAttachments ? (
          <div className="FileLoadingContainer">
            {attachments.map((attachment, index) => (
              <div
                key={attachment.uuid || `${attachment.file_name}_${index}`}
                className="FileLoadingContainerInfo"
              >
                {!attachment.loading ? (
                  <CheckmarkSharp color="#707070" height="20px" width="20px" />
                ) : (
                  ""
                )}

                <span>{attachment.file_name}</span>
              </div>
            ))}

            {loading ? (
              <div className="FileProgressContainer">
                <div
                  className="Progress"
                  style={{ width: `${percentsLoad}%` }}
                ></div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}

        <div className="ChatInputPanel">
          <span
            ref={this.msgRef}
            className="ChatInputMessage"
            role="textbox"
            contentEditable=""
            onKeyDown={this._handleKeyDown}
          ></span>
        </div>

        <div className="ChatSendMsgButton" onClick={this.sendMessage}>
          <Send color="#3b7cbe" height="40px" width="40px" />
          <div className="FileUploadPanel"></div>
        </div>
      </div>
    );
  }
}

export default MsgPanel;
